import React from "react";

import Step from "@mui/material/Step";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Check from "@mui/icons-material/Check";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";

import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material";

export default function StepperHeader({ steps, activeStep }) {
  if (steps.length > 1 && activeStep <= steps.length) {
    return (
      <Stack m={1}>
        <Stepper
          alternativeLabel
          sx={{ width: "100%" }}
          activeStep={activeStep - 1}
          connector={<QontoConnector />}
        >
          {steps.map((step, i) => {
            return (
              <Step key={i}>
                <StepLabel StepIconComponent={QontoStepIcon}>
                  <Typography
                    fontSize={10}
                    variant="caption"
                    color="text.secondary"
                  >
                    {step}
                  </Typography>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Stack>
    );
  }
}

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 8,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 18,
  alignItems: "center",
  ...(ownerState.active && {
    color: theme.palette.success.main,
  }),
  "& .QontoStepIcon-completedIcon": {
    color: theme.palette.success.main,
    zIndex: 1,
    fontSize: 16,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}
